import * as commonActionTypes from "../../shared/commonActionTypes";

const initialState = { reference: "", description:"",  isUdModule: false, udModuleUid: "", udModuleName:"", masterProcessName:"", masterProcessId:"", id:""};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case commonActionTypes.SET_MATTER:
      return { 
        reference: action.reference,
        description: action.description,
        isUdModule: action.isUdModule,
        udModuleUid: action.udModuleUid,
        udModuleName: action.udModuleName,
        masterProcessName: action.masterProcessName,
        masterProcessId: action.masterProcessId,
        id: action.id
      };
    case commonActionTypes.LOGOUT:
    case commonActionTypes.SET_CONTEXT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
